import { render, staticRenderFns } from "./TargetGroup.vue?vue&type=template&id=b1856b72&lang=pug"
import script from "./TargetGroup.vue?vue&type=script&lang=js"
export * from "./TargetGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports